import {
  PERFORMANCE_DEFAULT_SORTING,
  PERFORMANCE_FILTER_DEFAULT_MIN_STAR,
  PERFORMANCE_FILTER_INITIAL_MAX_STAR,
  PERFORMANCE_EXPORT_CSV_DELAY_MS,
  storesPerformanceExportHeaders,
} from "../../../constants/shared/performanceFilter.constants";

export const managerPerformanceConstants = {
  ALL_MANAGER_RESPONSE_DATA: "ALL_MANAGER_RESPONSE_DATA",
  CUSTOMER_RESPONSES_EXPORT_ALL_DATA: "CUSTOMER_RESPONSES_EXPORT_ALL_DATA",
  STORES_AVERAGE_SENTIMENT_AND_TRANSACTION_RATING:
    "STORES_AVERAGE_SENTIMENT_AND_TRANSACTION_RATING",
};

export const managerPerformanceDefaultSorting = PERFORMANCE_DEFAULT_SORTING;
export const MANAGER_PERFORMANCE_DEFAULT_MIN_STAR =
  PERFORMANCE_FILTER_DEFAULT_MIN_STAR;
export const MANAGER_PERFORMANCE_INITIAL_MAX_STAR =
  PERFORMANCE_FILTER_INITIAL_MAX_STAR;
export const MANAGER_PERFORMANCE_EXPORT_CSV_DELAY_MS =
  PERFORMANCE_EXPORT_CSV_DELAY_MS;

export const managerPerformanceExportHeaders = storesPerformanceExportHeaders;

export const managerPerformanceStoresName = "Manager Performance (Stores)";
